import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Popover } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import OnTraccrButton from '../common/buttons/OnTraccrButton';
import ProjectColumnChangerContent from './ProjectColumnChangerContent';

const baseOptions = [
  { label: 'Name', value: 'name' },
  { label: 'Number', value: 'number' },
  { label: 'Address', value: 'address' },
  { label: 'City', value: 'city' },
  { label: 'Division', value: 'division' },
  { label: 'Active Users', value: 'activeUsers' },
  { label: 'Inactive Users', value: 'inactiveUsers' },
  { label: 'Customer', value: 'customer' },
  { label: 'Labels', value: 'labels' },
];

export default function ProjectColumnChanger({
  onChange,
}) {
  const bucketTemplates = useSelector((state) => state.buckets.bucketTemplates);

  // Filter bucket templates that have projects as a downstream type
  const projectBucketTemplates = bucketTemplates.filter((template) => (
    template.downstreamTypes?.some((type) => type === 'project-one' || type === 'project-many')
  ));
  const bucketOptions = projectBucketTemplates.map(({ id, name }) => ({
    label: name,
    value: id,
  }));

  const defaultOptions = baseOptions.map((opt) => opt.value);
  const [selected, setSelected] = useState(() => {
    try {
      const storedChecked = window.localStorage.getItem('projectColumns');
      return storedChecked ? JSON.parse(storedChecked) : defaultOptions;
    } catch {
      return defaultOptions;
    }
  });
  const selectedSet = new Set(selected);

  useEffect(() => {
    onChange(selected);
  }, [selected]);

  const checkboxOnChange = (key) => (newChecked) => {
    if (newChecked) {
      // Add the key to the selected set
      setSelected((prev) => {
        const newSelected = [...prev, key];
        window.localStorage.setItem('projectColumns', JSON.stringify(newSelected));
        return newSelected;
      });
      return;
    }

    // Remove the key from the selected set
    setSelected((prev) => {
      const newSelected = prev.filter((item) => item !== key);
      window.localStorage.setItem('projectColumns', JSON.stringify(newSelected));
      return newSelected;
    });
  };

  return (
    <Popover 
      trigger='click'
      placement='bottomRight'
      content={
        <ProjectColumnChangerContent 
          selectedSet={selectedSet} 
          onChange={checkboxOnChange} 
          baseOptions={baseOptions}
          bucketOptions={bucketOptions}
        />
      }
    >
      <OnTraccrButton
        title='Columns'
        icon={<SettingOutlined />}
        type='cancel'
      />
    </Popover>
  );
}

ProjectColumnChanger.propTypes = {
  onChange: PropTypes.func.isRequired,
};